import { useEffect, useState } from 'react'

import { useAlert } from 'ui/alert'

import { useUser } from 'components/user'

import { routes } from 'const/routes'
import { useRedirect } from 'router'
import { authStorage } from 'api/storage'

const REQUIRED_USER_FIELDS = ['roles', 'name', 'email', 'region', 'accreditationType']
const REQUIRED_USER_FIELDS_NON_ACCREDITED = ['roles', 'name', 'email', 'region']

export const isUserProfileComplete = (user) => {
  if (user?.accredited) {
    return REQUIRED_USER_FIELDS.every((field) => Boolean(user?.[field]))
  }
  return REQUIRED_USER_FIELDS_NON_ACCREDITED.every((field) => Boolean(user?.[field]))
}

export const ProfileCompleteProvider = ({ children }) => {
  const alert = useAlert()
  const redirect = useRedirect()
  const user = useUser()
  const [isAuthenticated, setAuthenticated] = useState(authStorage.isAuthenticated())
  const isFullAuthenticated = authStorage.isFullAuthenticated()

  useEffect(() => authStorage.addListener(setAuthenticated), [])

  useEffect(() => {
    if (isAuthenticated && user?.externallyRegistered) {
      const isAccountSettingsPage = location.pathname === routes.accountSettings
      const isComplete = isUserProfileComplete(user)
      if (!isComplete && !isAccountSettingsPage && isFullAuthenticated) {
        alert.warning('Please complete your profile')
        redirect(routes.accountSettings)
      }
    }
  }, [user, isAuthenticated, redirect, isFullAuthenticated, alert])

  return children
}
